<app-async-block [inRequest]="(performanceFacade.mktCapInRequest$ | async) === true">
  <app-performance-win-table
    [columns]="MARKET_CUB_COLUMNS"
    [order]="(performanceFacade.mktCapOrder$ | async) || DEFAULT_MKT_CAP_ORDER"
    [sortBy]="(performanceFacade.mktCapSortBy$ | async) || DEFAULT_MKT_CAP_SORT_BY"
    [performanceRates]="(data$ | async) || []"
    [performanceRatesTotal]="total$ | async"
    [performanceRatesResults]="results$ | async"
    (changeSort)="changeSort($event.sortBy, $event.order)"
  >
    <ng-container title>{{ 'performance.winRatesByMarketCup.title' | translate }}</ng-container>
    <ng-container subtitle>
      <p>{{ 'performance.winRatesByMarketCup.subTitle' | translate }}</p>
      <ul>
        <li>{{ 'performance.winRatesByMarketCup.description.win' | translate }}</li>
        <li>{{ 'performance.winRatesByMarketCup.description.error' | translate }}</li>
      </ul>
    </ng-container>
  </app-performance-win-table>
</app-async-block>
